export const news = [
  {
    name: 'Index',
    url: '/news/',
    icon: 'icon-home'
  },
  {
    name: 'Create News',
    url: '/news/create',
    icon: 'icon-plus'
  }
];
